import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import BaseModal from '../../components/BaseModal';
import ButtonPrimary from '../../components/ui/ButtonPrimary';
import ButtonTransparent from '../../components/ui/ButtonTransparent';

import './index.css';

const DeleteDealerModal = (props) => {
  const [formValues, setFormValues] = useState({
    reason: '',
  });

  const updateFields = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value
    });
  }

  const submit = (e) => {
    e.preventDefault();
  }
  const body = (
    <div className="delete-dealer__body">
      <h2 className="delete-dealer__title modal__body-title">
        {'Delete ' + props.title}
      </h2>
      <form className="delete-dealer__form form" onSubmit={submit}>
        <div className="form__group form__group--textarea">
          <label className="form__textarea-label" htmlFor="reason">Please enter the reason</label>
          <textarea className="form__textarea-input" id="reason" type="text" value={formValues.reason} name="reason" onChange={updateFields}/>
        </div>
        <div className="delete-dealer__btn-group form__group">
          <ButtonPrimary 
            className="btn btn--primary" 
            name="Delete Dealer" 
            onClick={() => props.onDelete(formValues.reason)} 
          />
          <ButtonTransparent 
            className="btn btn--transparent" 
            name="Cancel" 
            onClick={props.onClose} 
          />
        </div>
      </form>
    </div>
  );

  return (
    <BaseModal body={body} footer={null} onClose={props.onClose}/>
  );
}

export default withRouter(DeleteDealerModal);